import { render } from "./AppointmentBooking.vue?vue&type=template&id=cdd61b4a&scoped=true"
import script from "./AppointmentBooking.vue?vue&type=script&lang=js"
export * from "./AppointmentBooking.vue?vue&type=script&lang=js"

import "./AppointmentBooking.vue?vue&type=style&index=0&id=cdd61b4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd61b4a"]])

export default __exports__